module.exports = __webpack_public_path__ + "img/a3.f9548038.png";